import { __assign, __rest } from "tslib";
import React from 'react';
import { IconChevronUp } from '@at/design-system-icons';
import { StyledVisuallyHiddenContainer } from '@at/design-system-foundation';
import * as Styles from './back-to-top.styled';
import { handleBackToTop } from './back-to-top-utils';
export var BackToTop = function (_a) {
    var otherHTMLProperties = __rest(_a, []);
    return (React.createElement(Styles.BackToTop, __assign({ onClick: handleBackToTop }, otherHTMLProperties),
        React.createElement(Styles.BackToTopIcon, null,
            React.createElement(IconChevronUp, { title: "chevron up", customSize: { width: 14, height: 14 }, "data-label": "back to top" })),
        React.createElement(Styles.BackToTopText, { as: "p", "data-label": "back to top" },
            "Back to top ",
            React.createElement(StyledVisuallyHiddenContainer, { as: "span" }, " of the page"))));
};
